import React, { useEffect, useState } from 'react';
import styles from './SeniorCarousel.module.scss';
import img1 from './CarouselImages/img1.jpg';
import img2 from './CarouselImages/img2.jpg';
import img3 from './CarouselImages/img3.jpg';
import img4 from './CarouselImages/img4.jpg';
import img5 from './CarouselImages/img5.jpg';
import img6 from './CarouselImages/img6.jpg';
import img7 from './CarouselImages/img7.jpg';
import img8 from './CarouselImages/img8.jpg';
import img9 from './CarouselImages/img9.jpg';
import ElasticCarousel from 'react-elastic-carousel';
import './carousel-overrides.scss';
import useBreakpoints from '../../../hooks/use-breakpoints';

const SRCS = [
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
  img7,
  img8,
  img9,
];

export default function SeniorCarousel() {
  const breakpoint = useBreakpoints();
  const [numItems, setNumItems] = useState(1);

  useEffect(() => {
    if (breakpoint === 'sm') setNumItems(1);
    if (breakpoint === 'md') setNumItems(3);
    if (breakpoint === 'xl') setNumItems(5);
  }, [breakpoint]);

  return (
    <div className={styles.seniorCarousel}>
      <p className={styles.title}>Seniors <em>shine</em> with Shoob Photography</p>
      <ElasticCarousel itemsToShow={numItems} outerSpacing={8} itemPadding={[8, 8, 8, 8]}>
        {SRCS.map((src) => (
          <div className={styles.imgWrapper} key={src}>
            <img className={styles.img} src={src} />
          </div>
        ))}
      </ElasticCarousel>
    </div>
  );
}
